import PropTypes from 'prop-types';
import * as React from 'react';
import { LegacyListboxButton } from './legacy.listbox-button.component.js';
import { LegacyListboxList } from './legacy.listbox-list.component.js';
import { LegacyListboxPopover } from './legacy.listbox-popover.component.js';
import { LegacyListbox } from './legacy.listbox.component.js';
import { renderWithRef } from '../../../react/components/core/render-with-ref.js';

function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }

  return target;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _object_spread_props(target, source) {
  source = source != null ? source : {};

  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _object_without_properties(source, excluded) {
  if (source == null) return {};

  var target = _object_without_properties_loose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _object_without_properties_loose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var propTypes = {
  /**
  * Enable the combobox dropdown to overflow outside the modal dialog.
  */
  inModal: PropTypes.bool
};
var LegacyBasicListbox = renderWithRef('LegacyBasicListbox', propTypes, function (props, ref) {
  var _props$arrow = props.arrow,
      arrow = _props$arrow === void 0 ? false : _props$arrow,
      button = props.button,
      children = props.children,
      _props$inModal = props.inModal,
      inModal = _props$inModal === void 0 ? false : _props$inModal,
      _props$portal = props.portal,
      portal = _props$portal === void 0 ? true : _props$portal,
      darkMode = props.darkMode,
      bgc = props.bgc,
      backgroundColor = props.backgroundColor,
      ariaLabel = props['aria-label'],
      otherProps = _object_without_properties(props, ["arrow", "button", "children", "inModal", "portal", "darkMode", "bgc", "backgroundColor", 'aria-label']);

  var bgColor = bgc || backgroundColor;
  return /*#__PURE__*/React.createElement(LegacyListbox, _object_spread_props(_object_spread({
    darkMode: darkMode,
    bgc: bgColor
  }, otherProps), {
    ref: ref
  }), function (_ref) {
    var value = _ref.value,
        valueLabel = _ref.valueLabel;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LegacyListboxButton, {
      "aria-label": ariaLabel,
      arrow: arrow
    }, typeof button === 'function' ? button({
      value: value,
      label: valueLabel
    }) : button), /*#__PURE__*/React.createElement(LegacyListboxPopover, {
      darkMode: darkMode,
      bgc: bgColor,
      portal: portal,
      inModal: inModal
    }, /*#__PURE__*/React.createElement(LegacyListboxList, null, children)));
  });
});
LegacyBasicListbox.defaultProps = {
  inModal: false
};
export { LegacyBasicListbox };